import React, { Component } from 'react';
import { isEmpty } from '../../../Common/Common';
import Top_Bar from '../../../Part_Sample/Top_Bar';

export default class Rooms extends Component {
	constructor(props) {
		super(props);

		// Set default guest_room_setting in case of first time open
		this.guest_room_settings = {
			locations: [],
			rooms: {}
		};
		if (!isEmpty(this.props.param.guest_room_settings)) {
			this.guest_room_settings = JSON.parse(JSON.stringify(this.props.param.guest_room_settings));
		}

		this.state = {

		}
	}

	handlePrevious = () => {
		this.props.content_handler('Guest_Room_Settings', this.props.param);
	}

	handleEditRoom = (room_name) => {
		let param = this.props.param;
		param.selected_room = room_name;
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Edit_Guest_Room', param);
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let button_style = {
			width: this.props.width - 40,
			backgroundColor: 'white',
			marginTop: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 20,
			textAlign: 'left',
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('rooms')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ overflow: 'auto', paddingBottom: 60, height: this.props.height - 120 }}>
						<div style={{ display: isEmpty(this.guest_room_settings.locations) ? 'block' : 'none' }}>
							<span className='subtitle'>{this.props.receiver.getString('no_locations')}</span>
						</div>
						{Object.keys(this.props.param.guest_rooms).map((room_name) => {
							return (
								<div style={button_style}>
									<div style={{ cursor: 'pointer', display: 'inline-block', width: this.props.width - 60, textAlign: 'left', verticalAlign: 'top', marginLeft: 10, paddingTop: 15, paddingBottom: 15 }} onClick={() => this.handleEditRoom(room_name)}>
										<span>{room_name}</span>
									</div>
								</div>
							)
						})}
					</div>
				</div>
			</div>
		)
	}
}